import React from 'react'
import log from 'loglevel'
import { LinkIcon } from 'src/components/Icons/FileType'
import { openInNewTab } from 'src/Utils/globalHelpers'
import { getReceptorTemplate } from 'src/xgenerated'
import { TextButton } from '../Buttons/TextButton'

export const ViewInSourceButton = ({
  receptorModelId,
  link,
  shortName,
}: {
  receptorModelId: string
  link: string
  shortName?: string
}): JSX.Element => {
  let receptorName = 'Source'

  if (shortName) {
    receptorName = shortName
  } else {
    try {
      const receptorTemplate = getReceptorTemplate(receptorModelId)
      receptorName = receptorTemplate?.name || 'Source'
    } catch (e) {
      if (receptorModelId.startsWith('trr-')) {
        log.error('Error getting receptor template', e)
      } else {
        log.info(
          'Invalid receptor model id. Possibly a user uploaded document with the same caption as a linked document.',
          e,
        )
      }
    }
  }

  return (
    <TextButton
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        openInNewTab(link)
      }}
    >
      {`View in ${receptorName}`}
      <LinkIcon />
    </TextButton>
  )
}
